export const brand = {
  name: "l'azote",
  // Switch to local assets for reliability
  logoUrl: "/logo.png",
  smallLogoUrl: "/logo-small.png",
  footerLogoUrl: "/logo-footer.png",
  colors: {
    navy: "#002D72",
    navy600: "#003A8C",
    navy700: "#001F4D",
    cyan: "#28D8FF",
    cyan600: "#11C7F2",
    slate: "#0f1115",
  },
  heroImages: [
    "https://unsplash.com/photos/aVjegSvlFHk/download?force=true&w=1600",
    "https://images.unsplash.com/photo-1644088379091-d574269d422f?q=85&auto=format&fit=crop&w=1400",
    "https://images.unsplash.com/photo-1750969185331-e03829f72c7d?q=85&auto=format&fit=crop&w=1400",
  ],
};

export const services = [
  {
    id: "os",
    icon: "Server",
    title: "Operating System Hardening",
    punchline: "Angriffsfläche minimieren. Standards einhalten.",
    bullets: [
      "Deaktivierung unnötiger Dienste",
      "Regelmässige Sicherheitsupdates",
      "Strikte Zugriffskontrollen",
      "CIS/NIST-konforme Baselines",
    ],
    details: {
      intro:
        "Wir härten Windows zielgerichtet. Du bekommst reproduzierbare Baselines, dokumentierte Abweichungen und messbare Verbesserungen.",
      deliverables: [
        "Baseline-Playbooks (CIS-orientiert)",
        "Härtungsreport mit Vorher/Nachher-Score",
        "Ausrollkonzept inkl. Change-Vorschlägen",
      ],
      process: [
        "Assessment & Gap-Analyse",
        "Pilot-Härtung (1–2 Systeme)",
        "Rollout & Dokumentation",
      ],
    },
  },
  {
    id: "ad",
    icon: "Network",
    title: "Active Directory Hardening",
    punchline: "Identitäten absichern. Missbrauch verhindern.",
    bullets: [
      "Privilegierte Konten absichern",
      "MFA durchsetzen",
      "GPOs straffen & überwachen",
      "Service Accounts minimieren",
    ],
    details: {
      intro:
        "Wir stabilisieren AD-Architekturen, reduzieren Privilegien und schaffen Audit-Transparenz – ohne die Produktivität zu bremsen.",
      deliverables: [
        "Tiering/PAW-Empfehlungen",
        "GPO-Härtungsset mit Testrichtlinien",
        "Monitoring-Empfehlungen (Auditing, Logs)",
      ],
      process: [
        "Privilege Review",
        "MFA- & GPO-Konzept",
        "Umsetzung & Schulung",
      ],
    },
  },
  {
    id: "vuln",
    icon: "Shield",
    title: "Vulnerability Hardening",
    punchline: "Schwachstellen finden und nachhaltig schliessen.",
    bullets: [
      "Detaillierte Scans & Priorisierung",
      "Patchen & Konfigurationsanpassungen",
      "Standards aligned Optimierungen",
    ],
    details: {
      intro:
        "Wir kombinieren Scanner-Resultate mit Hands-on-Validierung und setzen die wichtigsten Massnahmen zuerst um.",
      deliverables: [
        "Backlog mit Risiko-Priorisierung",
        "Fix-Playbooks (Patch/Config)",
        "Executive Summary für Management",
      ],
      process: [
        "Scan & Validierung",
        "Fix-Sprint(s)",
        "Retest & Nachweis",
      ],
    },
  },
  {
    id: "perm",
    icon: "KeyRound",
    title: "Permission Management",
    punchline: "Minimalprinzip und Rollen-Modelle etablieren.",
    bullets: [
      "Analyse aller Berechtigungen",
      "RBAC & klare Richtlinien",
      "Veraltete Konten entfernen",
      "Dokumentation & Übergabe",
    ],
    details: {
      intro:
        "Klarheit in Berechtigungen: wir räumen auf, definieren Rollen und machen Rechte prüfbar.",
      deliverables: [
        "Rollenmodell & Namenskonventionen",
        "Rezertifizierungs-Workflow",
        "Dokumentation & Übergabe",
      ],
      process: [
        "Ist-Analyse",
        "RBAC-Design",
        "Implementierung & Governance",
      ],
    },
  },
];

// Funnel-/Stufen-Ansicht: Einstieg → Assessment → Umsetzung → Betreuung
export const journey = [
  {
    step: "01",
    stage: "Einstieg",
    icon: "Compass",
    title: "Kennenlernen & Standortbestimmung",
    description:
      "Niedrigschwelliger Einstieg – wir verstehen deine Umgebung und zeigen erste Risiken auf.",
    packages: [
      {
        id: "erstgespraech",
        name: "Kostenloses Erstgespräch",
        tagline: "Unverbindlich & kostenlos",
        primary: true,
        bullets: [
          "Kurzes Kennenlernen",
          "Erste Einschätzung deiner Situation",
          "Klare Empfehlung für die nächsten Schritte",
        ],
        cta: "Termin vereinbaren",
      },
      {
        id: "quick-check",
        name: "Microsoft Security Quick Check",
        tagline: "Erstes bezahltes Produkt",
        bullets: [
          "Kurzgespräch & Grobprüfung",
          "Management-Report (2–3 Seiten)",
          "Anrechenbar auf ein folgendes Assessment",
        ],
        cta: "Auf Anfrage",
      },
    ],
  },
  {
    step: "02",
    stage: "Assessment",
    icon: "Search",
    title: "Tiefenanalyse & Risikobewertung",
    description:
      "Strukturierte Prüfung deiner Cloud- und lokalen Microsoft-Umgebung mit klaren Prioritäten.",
    packages: [
      {
        id: "m365-review",
        name: "M365 Security Review",
        tagline: "Cloud-Security Einstieg",
        bullets: [
          "MFA & Conditional Access",
          "Entra ID Review",
          "Exchange & SharePoint Review",
        ],
        cta: "Auf Anfrage",
      },
      {
        id: "ad-assessment",
        name: "AD Security Assessment",
        tagline: "Lokale Microsoft-Umgebung",
        bullets: [
          "Executive Summary & Findings",
          "Priorisierung der Risiken",
          "Konkreter Massnahmenplan",
        ],
        cta: "Auf Anfrage",
      },
    ],
  },
  {
    step: "03",
    stage: "Umsetzung",
    icon: "Wrench",
    title: "Hardening Sprints",
    description:
      "Wir setzen die priorisierten Massnahmen technisch um – mit Abnahme und Nachkontrolle.",
    packages: [
      {
        id: "sprint-small",
        name: "Hardening Sprint Small",
        tagline: "Priorisierte Quick Wins",
        bullets: [
          "Technische Verbesserungen",
          "Abnahme der Massnahmen",
          "Nachkontrolle",
        ],
        cta: "Auf Anfrage",
      },
      {
        id: "sprint-medium",
        name: "Hardening Sprint Medium",
        tagline: "Mehrere Findings & Standards",
        recommended: true,
        bullets: [
          "Detaillierter Projektplan",
          "Technische Umsetzung",
          "Vollständige Dokumentation",
        ],
        cta: "Auf Anfrage",
      },
    ],
  },
  {
    step: "04",
    stage: "Betreuung",
    icon: "ShieldCheck",
    title: "Laufende Sicherheit",
    description:
      "Wiederkehrende Kontrolle, Reporting und Beratung – damit dein Schutzniveau dauerhaft hoch bleibt.",
    packages: [
      {
        id: "security-care",
        name: "Security Care",
        tagline: "Monatlicher Basisservice",
        monthly: true,
        bullets: ["Quartalsreview", "Report", "1 h Beratung"],
        cta: "Auf Anfrage",
      },
      {
        id: "security-plus",
        name: "Security Plus",
        tagline: "Stärkerer Monatsservice",
        monthly: true,
        recommended: true,
        bullets: ["Monatsreview", "Scan & Report", "2 h Beratung"],
        cta: "Auf Anfrage",
      },
    ],
  },
];

export const team = [
  { name: "Amin Zran", role: "Founder & Project Management", image: "https://images.squarespace-cdn.com/content/v1/67a3a05fda75364600a9d872/97bdb4f9-e965-4093-ac73-1b1eae24807e/IMG_2260.jpg" },
  { name: "Claudio Steyskal", role: "Co‑Founder & System Manager", image: "https://images.squarespace-cdn.com/content/v1/67a3a05fda75364600a9d872/2ee40398-456c-4c29-af12-ccbc0b83e5ee/WhatsApp+Image+2025-06-18+at+22.17.17.jpg" },
  { name: "Amer Barjaktarevic", role: "Lead System Manager & Customer Service", image: "/team/amer.jpg" },
  { name: "Nicolas Huber", role: "Lead Legal & Finance", image: "/team/nicolas.jpg" },
];

export const faqs = [
  { q: "Wie schnell meldet ihr euch?", a: "In der Regel innerhalb von 24 Stunden – bei dringenden Vorfällen sofort." },
  { q: "Arbeitet ihr nach CIS/NIST?", a: "Ja. Unsere Baselines orientieren sich an CIS Benchmarks und NIST-Empfehlungen." },
  { q: "Könnt ihr bestehende Audits/Scans übernehmen?", a: "Selbstverständlich. Wir integrieren vorhandene Reports und priorisieren gemeinsam Massnahmen." },
];

export const contactConfig = {
  company: "l'azote",
  emailFallback: "info@lazote.ch",
  phone: "",
  address: "Schweiz",
};